type ProjectPermissionInput = {
  projectRole?: string | null;
  roleLoading?: boolean;
  userRole?: string | null;
  userEmail?: string | null;
};

export const getProjectPermissionFlags = ({
  projectRole,
  roleLoading,
  userRole,
  userEmail,
}: ProjectPermissionInput) => {
  const normalizedProjectRole = (projectRole || '').toLowerCase();
  const normalizedUserRole = (userRole || '').toLowerCase();
  const normalizedEmail = (userEmail || '').toLowerCase();

  const isProjectManagerFromRole =
    normalizedProjectRole === 'project_manager' || normalizedProjectRole === 'admin';
  const isModerator = normalizedProjectRole === 'moderator';
  const isScheduler = normalizedProjectRole === 'scheduler';

  const canFallbackToGlobalRole =
    !roleLoading &&
    !normalizedProjectRole &&
    (normalizedUserRole === 'project_manager' ||
      normalizedUserRole === 'admin' ||
      normalizedEmail.endsWith('@centific.com'));

  return {
    isProjectManager: isProjectManagerFromRole || canFallbackToGlobalRole,
    isModerator,
    isScheduler,
    isAdmin: normalizedProjectRole === 'admin' || normalizedUserRole === 'admin',
  };
};
